module.exports = __webpack_public_path__ + "static/media/JustFleckless–05Camel.64390ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/JustFleckless–05Camel.jpg
// module id = 21
// module chunks = 0